import { useEffect, useState } from 'react';
import { useLoginInfo } from '../../../global-utils';
import { useDIT } from '../model/hooks';
import { dataInsightInit, extendUser, getSettings } from '../model/utils';
import { getIsAdminPreview } from '../../../shared/admin-preview';
import { useBookedTickets, useCoreUser } from '../../../shared/m-anage';
import { emptyNull } from '../../../shared/misc';

// This component is not loaded to core components if the module is not active
const Init = () => {
  const userLoginInfo = useLoginInfo();
  const moduleConfig = getSettings();
  // data-insight params:
  const dit = useDIT();
  const bookedTickets = useBookedTickets();
  const extendedUser = useCoreUser();
  const [user, setUser] = useState(emptyNull);

  const canInit = Boolean(
    !getIsAdminPreview() // preview in iFrame
      && moduleConfig?.authKey // must have authKey
      && dit // module JS files finished loading
  );

  useEffect(() => {
    setUser(
      extendUser({
        userLoginInfo,
        extendedUser: extendedUser.data,
        bookedTickets: bookedTickets.data
      })
    );
  }, [userLoginInfo, bookedTickets.data, extendedUser.data]);

  useEffect(() => {
    if (canInit) dataInsightInit(user);
  }, [user, canInit]);

  return null;
};

export default Init;
